import {AccessorWithLatest, createAsync} from "@solidjs/router";
import {createContext, JSXElement, useContext} from "solid-js";
import {getUser, User} from "~/api/auth";

const UserContext = createContext<AccessorWithLatest<User | null | undefined>>();

export default function UserProvider(props: { children: JSXElement }) {
    const user = createAsync(async () => getUser())

    return (
        <UserContext.Provider value={user}>
            {props.children}
        </UserContext.Provider>
    );
}

export function useUser() {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("useUser must be used within a UserProvider")
    }
    return context
}